<template >
  <v-container>
    <v-row class="ma-3 mb-5">
      <v-col cols="12" sm="12" md="6" xl="6" align-self="center">
        <v-card flat>
          <v-card-text>
            <h1 class="display-2 text-center ma-3">Contact Me</h1>
            <v-col cols="12">
              <v-icon class="mr-3">mdi-map-marker</v-icon>Boumerdes -Algeria
            </v-col>
            <v-col cols="12">
              <v-icon class="mr-3">mdi-email</v-icon>fa_meherhera@esi.dz
            </v-col>
            <v-col cols="12">
              <v-icon class="mr-3">mdi-linkedin</v-icon>
              <a href="https://www.linkedin.com/in/amina-meherhera-b63323135/">Amina Meherhera</a>
            </v-col>
            <v-col cols="12">
              <v-icon class="mr-3">mdi-github</v-icon>
              <a href="github.com/MinaMeh">MinaMeh</a>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6" xl="6" align="center" justify="center">
        <img class="pic" src="/images/pc.jpeg" alt />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  date() {
    return {};
  }
};
</script>